export default __webpack_public_path__ + "static/media/tanscoding-failure-icon.d1fac937.svg";